


































import { Vue, Component, Model, Watch, Prop } from "vue-property-decorator";
import { VIPIp, busy, db, VipIpRequestStatus } from '@/loader';

@Component
export default class IpSelect extends Vue {
	@Model("input", { default: null })
	public readonly value!: any;

	@Prop({ type: Boolean, default: false })
	public readonly multiple!: boolean;

	@Prop({ type: Boolean, default: false })
	public readonly canEdit!: boolean;

	@Prop({ type: Array, default: () => [] })
	public readonly include!: VIPIp[];

	@Prop({ type: Array, default: () => [] })
	public readonly exclude!: VIPIp[];

	@Prop({ type: Function, default: (option) => option.id })
	public readonly reduce!: Function;

	@Prop({ type: Boolean, default: false })
	public readonly allowDisabled!: boolean;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get ips(): VIPIp[] {
		return db.ips.list
			.filter(ip => (ip.isActive || this.allowDisabled) && (!this.include.length || this.include.includes(ip)) && !this.exclude.includes(ip))
			.sort((a, b) => a.code.toString().localeCompare(b.code.toString()));
	}

	public filter(options: VIPIp[], search: string) {
		search = search.toLowerCase().removeDiacritics();
		return options.filter(option => option.toString().toLowerCase().removeDiacritics().includes(search));
	}
}
